var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoyaltyPointIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3203",
    "data-name": "Rectangle 3203",
    width: 24,
    height: 24,
    transform: "translate(46 389)",
    fill: "none",
    stroke: "#fdba18",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5906",
    "data-name": "Mask Group 5906",
    transform: "translate(-46 -389)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7521",
    "data-name": "Group 7521",
    transform: "translate(-1.001 -0.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vip",
    d: "M19.473,14.511l-1.974,7.6a1.03,1.03,0,0,1-.994.77h-11a1.03,1.03,0,0,1-.994-.77l-1.974-7.6A1.027,1.027,0,0,1,3.9,13.292l3.271,1.26a.166.166,0,0,0,.19-.052L10.2,10.868a1.023,1.023,0,0,1,1.62,0L14.648,14.5a.166.166,0,0,0,.19.052l3.271-1.26a1.035,1.035,0,0,1,1.363,1.219Z",
    transform: "translate(47.997 383.189)",
    fill: "none",
    stroke: "#fdba18",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x2: 12.751,
    transform: "translate(52.625 409.429)",
    fill: "none",
    stroke: "#fdba18",
    strokeLinecap: "round",
    strokeWidth: 1.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyPointIcon);
export default __webpack_public_path__ + "static/media/LoyaltyPointIcon.6e6142b4e1d394af12b819d0c3cc7b5d.svg";
export { ForwardRef as ReactComponent };